export type SortOrder = 'asc' | 'desc';
export const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;
